<script>
import LABELS from '@/constants/labels'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'Home',
  components: { VueSlickCarousel },
  data() {
    return {
      mainTool: 'term',
      slickOptionsImgR: {
        slidesToShow: 1,
        autoplay: true,
        centerMode: true,
        variableWidth: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 6900,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        cssEase: 'linear',
        slidesToScroll: 1,
        rtl: true,
      },
      slickOptionsImgL: {
        slidesToShow: 1,
        autoplay: true,
        centerMode: true,
        variableWidth: true,
        arrows: false,
        autoplaySpeed: 0,
        speed: 6900,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        cssEase: 'linear',
        slidesToScroll: 1,
        rtl: false,
      },
      dataGuideHome: [
        {
          type: 'type1',
          title: 'STEP',
          numberTitle: 2,
          subTitle: '形を選ぼう',
          bgImage: require('@/assets/images/home-page/home-bg-1.png'),
          image: require('@/assets/images/home-page/guide-step1.png'),
          description:
            '横長のMINTIA、 <br />縦長のMINTIA BREEZEの<br />どちらにするか選ぼう！',
        },
        {
          type: 'type1',
          title: 'STEP',
          numberTitle: 2,
          subTitle: 'テンプレートを選ぼう',
          bgImage: require('@/assets/images/home-page/home-bg-2.png'),
          image: require('@/assets/images/home-page/guide-step2.png'),
          description:
            '作りたいMYラベルに合わ<br />せて、オリジナルのテン<br />プレートを選ぼう！',
        },
        {
          type: 'type2',
          title: 'STEP',
          numberTitle: 3,
          subTitle: '自由に編集しよう',
          bgImage: require('@/assets/images/home-page/guide-bg-step3.png'),
          bgPosition: '35% 35%',
          content: [
            {
              type: 'col',
              class: 'step3-part1',
              col1: [
                {
                  image: require('@/assets/images/home-page/guide_step3-1.jpg'),
                },
              ],
              col2: [
                {
                  title: '背景',
                  class: 'step3-col2-part1-title-class',
                },
                {
                  text:
                    '背景画像はいつでも<br/>変更できます。 <br/>自由に編集してみましょう！',
                },
              ],
            },
            {
              type: 'col',
              col1: [
                {
                  title: 'アバター',
                  class: 'step3-col2-part1-title-class',
                },
                {
                  text:
                    'アバターを2つまで<br/>作成して追加できます。<br/>あの人の似顔絵を作ってみるのもいいかも？',
                  class: 'step3-col1-part2-text-class',
                },
                {
                  image: require('@/assets/images/home-page/guide_step3-3.jpg'),
                },
              ],
              col2: [
                {
                  image: require('@/assets/images/home-page/guide_step3-2.jpg'),
                },
                {
                  text:
                    'アバターの位置は直接触って動かせます。<br/>アバターの大きさはスライダーで変更できます。',
                  class: 'step3-col2-part2-text-class',
                },
              ],
            },
            {
              type: 'text-block',
              text:
                '※ MINTIAロゴありの背景を使っている場合は、ロゴの上にはアバターを表示できません。',
              class: 'step3-part3',
            },
            {
              type: 'col',
              col1: [
                {
                  image: require('@/assets/images/home-page/guide_step3-4.jpg'),
                },
                {
                  text:
                    'スタンプの位置は直接触って動かせます。<br/>スタンプの大きさと角度は、スライダーで変更できます。',
                  class: 'step3-col1-part4-text-class',
                },
              ],
              col2: [
                {
                  title: 'スタンプ',
                  class: 'step3-col2-part1-title-class',
                },
                {
                  text:
                    'スタンプを5つまで追加できます。<br/>装飾や吹き出しなど、使い方は工夫次第で無限大！',
                  class: 'step3-col2-part4-text-class',
                },
                {
                  image: require('@/assets/images/home-page/guide_step3-5.png'),
                },
              ],
            },
            {
              type: 'text-block',
              text:
                '※ MINTIAロゴありの背景を使っている場合は、ロゴの上にはスタンプを表示できません',
              class: 'step3-part5',
            },
            {
              type: 'col',
              col1: [
                {
                  title: 'テキスト',
                  class: 'step3-part6-col1-title',
                },
                {
                  text: 'テキストを5つまで追加できます。',
                },
                {
                  image: require('@/assets/images/home-page/guide_step3-6.png'),
                  class: 'step3-part6-col1-img',
                },
                {
                  image: require('@/assets/images/home-page/guide_step3-7.jpg'),
                },
              ],
              col2: [
                {
                  image: require('@/assets/images/home-page/guide_step3-8.jpg'),
                },
                {
                  text:
                    'テキストの位置は直接触って動かせます。<br/>テキストの大きさと角度は、スライダーで変更できます。',
                  class: 'step3-part6-col2-text-1',
                },
                {
                  text: '色とフォントの変更、テキスト内容の再編集も可能です。',
                },
              ],
            },
            {
              type: 'text-block',
              text:
                '※「MINTIA ロゴ風」のフォントは、MINTIAロゴなしの背景を使っているときのみ、1つのテキストにだけ設定できます。<br/>※ MINTIAロゴありの背景を使っている場合は、ロゴの上にはテキストを表示できません。<br/>※ MINTIAの商品名やブランド棄損に抵触しそうな文字、公序良俗に反する文字は打てない設定になっています。',
              class: 'step3-part7',
            },
          ],
        },
        {
          type: 'type2',
          title: 'STEP',
          numberTitle: 4,
          subTitle: '保存・印刷しよう',
          bgImage: require('@/assets/images/home-page/guide-bg-step4.png'),
          bgPosition: '63% -2%',
          slotImg: require('@/assets/images/home-page/guide_step-4-point.png'),
          content: [
            {
              type: 'col',
              col1: [
                {
                  image: require('@/assets/images/home-page/guide_step4-1.jpg'),
                },
              ],
              col2: [
                {
                  text:
                    '完成したMYラベルは、<br/>画像を長押しして、スマ<br/>ホのメニューから保存で<br/>きます。',
                  class: 'step4-part1-col2',
                },
              ],
            },
            {
              type: 'col',
              class: 'step4-part2',
              col1: [
                {
                  text:
                    '印刷用データは用紙のサイズに合わせて3種類ご用意。<br/><br/>シールプリントに対応したマルチコピー機があるコンビニやご家庭のプリンターで、すぐにMYラベルが印刷できます！※A4用紙の場合は「フチなし」設定にしてください。',
                  class: 'step4-part2-col1-text',
                },
                {
                  text:
                    'また、つくったアバターをSNSアイコンとして利用することも可能です。お好みでこちらも保存しましょう。',
                },
              ],
              col2: [
                {
                  image: require('@/assets/images/home-page/guide_step4-2.jpg'),
                },
              ],
            },
          ],
        },
      ],
      dataSlide1: [
        {
          id: 0,
          image: require('@/assets/images/home-page/frame_01@2x.png'),
        },
        {
          id: 1,
          image: require('@/assets/images/home-page/frame_02@2x.png'),
        },
        {
          id: 2,
          image: require('@/assets/images/home-page/frame_03@2x.png'),
        },
        {
          id: 3,
          image: require('@/assets/images/home-page/frame_04@2x.png'),
        },
        {
          id: 4,
          image: require('@/assets/images/home-page/frame_05@2x.png'),
        },
      ],
      dataSlide2: [
        {
          id: 0,
          image: require('@/assets/images/home-page/frame_06@2x.png'),
        },
        {
          id: 1,
          image: require('@/assets/images/home-page/frame_07@2x.png'),
        },
        {
          id: 2,
          image: require('@/assets/images/home-page/frame_08@2x.png'),
        },
        {
          id: 3,
          image: require('@/assets/images/home-page/frame_09@2x.png'),
        },
        {
          id: 4,
          image: require('@/assets/images/home-page/frame_10@2x.png'),
        },
      ],
      ugoki: [
        {
          firstSlider: Number,
          secondSlider: Number,
        },
      ],
    }
  },
  computed: {
    mappingLabels() {
      return LABELS
    },
  },
  methods: {
    handleScrollStep() {
      var el = document.getElementById('step1')
      el.scrollIntoView({ behavior: 'smooth' })
    },

    changeRandomSlider() {
      let randomSlider1 = Math.floor(Math.random() * this.dataSlide1.length)
      let randomSlider2 = Math.floor(Math.random() * this.dataSlide2.length)
      this.ugoki.firstSlider = randomSlider1
      this.ugoki.secondSlider = randomSlider2
    },

    customScroll() {
      var isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i)
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i)
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i)
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i)
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          )
        },
      }

      if (isMobile.any() == null) {
        let el = document.getElementsByClassName('all-page')[0]
        el.classList.add('all-page-scroll')
      } else {
        let el = document.getElementsByClassName('home-page')[0]
        el.classList.add('h-100vh')
      }
      let header = document.getElementsByClassName('home-page_header')[0]
      header.scrollIntoView()
    },
  },
  created() {
    this.changeRandomSlider()
  },
  mounted() {
    this.customScroll()
  },
}
</script>

<template>
  <div class="home-page">
    <div class="home-page_header">
      <div class="home-page_slider-group">
        <VueSlickCarousel class="slider-img" v-bind="slickOptionsImgR">
          <div
            class="slide-item slide-item__first"
            v-for="item of dataSlide1"
            :key="item.id"
            :class="{ ugoki: ugoki.firstSlider == item.id }"
          >
            <img :src="item.image" />
          </div>
        </VueSlickCarousel>
      </div>
      <div class="home-page_logo">
        <img
          :src="require('@/assets/images/home-page/logo_sp.svg')"
          alt="banner"
          class="logo"
        />
      </div>
      <div class="home-page_slider-group">
        <VueSlickCarousel class="slider-img" v-bind="slickOptionsImgL">
          <div
            class="slide-item slide-item__second"
            v-for="item of dataSlide2"
            :key="item.id"
            :class="{ ugoki: ugoki.secondSlider == item.id }"
          >
            <img :src="item.image" />
          </div>
        </VueSlickCarousel>
      </div>
      <div class="home-page_title-group">
        <h2 class="title">
          君だけの<span class="sub-title">[オリジナルラベル]</span>を作ろう！
        </h2>
      </div>
      <div class="home-page_header--mask"></div>
    </div>

    <div class="home-page_button-group">
      <router-link
        class="s-button blue-btn"
        :to="{ name: mainTool }"
        :title="mappingLabels.fileManagement"
        >ラベルをつくる</router-link
      >
      <a
        href="https://fun.asahi-gf.co.jp/"
        class="s-button white-blue-btn mt-3"
        target="_blank"
      >
        <img :src="require('@/assets/images/home-page/top_btn_toasahi.svg')" />
        へもどる
      </a>
      <div class="arrow-down_txt" v-on:click="handleScrollStep()">
        <div class="loading_line_wrapper">
          <div class="how_to_make">How to make</div>
          <div class="loading_line">
            <div class="loading_line_inner loading_line_inner--2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-guide-content">
      <p class="home-guide-title">
        <span class="text" v-html="mappingLabels.stepTitle"></span>
      </p>
      <div class="arrow-down_wrapper">
        <img
          v-on:click="handleScrollStep()"
          :src="require('@/assets/images/home-page/top_arrow.png')"
        />
      </div>
      <div class="guide-step__wrapper">
        <section class="step-section" id="step1">
          <div class="step-title">
            <img
              class="step-title__img"
              :src="require('@/assets/images/home-page/top_h_yellow.svg')"
            />
            <div class="step-title__subtitle">
              <span class="step-number">step 1</span>
              <p class="step-name">形をえらぼう</p>
            </div>
            <p class="txt-subtitle">CHOOSE CASE TYPE</p>
          </div>
          <div class="step-content">
            <div class="step-content__wrapper">
              <div class="step1-content__img">
                <img
                  class="step1-img"
                  :src="require('@/assets/images/home-page/case_01.png')"
                />
                <img
                  class="step1-img"
                  :src="require('@/assets/images/home-page/case_02.png')"
                />
              </div>
              <div class="step1-content__txt">
                <p>
                  横長のMINTIA、縦長のMINTIA BREEZEの<br />どちらかにするか選ぼう！
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="step-section">
          <div class="step-title">
            <img
              class="step-title__img"
              :src="require('@/assets/images/home-page/top_h_yellow.svg')"
            />
            <div class="step-title__subtitle">
              <span class="step-number">step 2</span>
              <p class="step-name">自由に編集しよう</p>
            </div>
            <p class="txt-subtitle">EDIT FREELY</p>
          </div>
          <div class="step-content mb-6">
            <div class="step-content__wrapper">
              <p class="step2-content__title">
                <span>[ </span>シチュエーション毎に背景を変更可能<span> ]</span>
              </p>
              <div class="step2-content__img">
                <img
                  class="step2-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step2_1.png')
                  "
                />
              </div>
              <div class="step2-content__txt">
                <p>
                  MINTIAのシンプルなロゴ背景以外にも、シチュエーションに合わせてたくさんの背景画像をご用意！
                  <br />背景画像はいつでも変更できるので自由に編集してみましょう！
                </p>
              </div>
            </div>
          </div>
          <div class="step-content mb-6">
            <div class="step-content__wrapper">
              <p class="step2-content__title">
                <span>[ </span>アバターを制作して追加できる!<span> ]</span>
              </p>
              <div class="step2-content__img">
                <img
                  class="step2-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step2_2.png')
                  "
                />
              </div>
              <div class="step2-content__txt">
                <p class="txt-1">
                  アバターを2つまで作成して追加できます。
                  あの人の似顔絵を作ってみるのもいいかも？
                </p>
                <p class="txt-2">
                  ※MINTIAロゴありの背景を使っている場合は、ロゴの上にアバターを表示できません。
                </p>
              </div>
            </div>
          </div>
          <div class="step-content mb-6">
            <div class="step-content__wrapper">
              <p class="step2-content__title">
                <span>[ </span>スタンプでデコレーションしよう<span> ]</span>
              </p>
              <div class="step2-content__img">
                <img
                  class="step2-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step2_3.png')
                  "
                />
              </div>
              <div class="step2-content__txt">
                <p class="txt-1">
                  スタンプを5つまで追加することができます。
                  装飾や吹き出しなど、使い方は工夫次第で無限大！
                </p>
              </div>
            </div>
          </div>
          <div class="step-content">
            <div class="step-content__wrapper">
              <p class="step2-content__title">
                <span>[ </span>テキストで更にオリジナリティUP<span> ]</span>
              </p>
              <div class="step2-content__img">
                <img
                  class="step2-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step2_4.png')
                  "
                />
              </div>
              <div class="step2-content__txt">
                <p class="txt-1">
                  テキストを5つまで追加できます。<br />
                  色とフォントの変更、テキストの内容の再編集も可能です。<br />
                  名前やメッセージ等を入れて、オリジナルラベルにカスタマイズ！
                </p>
                <p class="txt-2">
                  ※「MINTIA
                  ロゴ風」のフォントは、MINTIAロゴなしの背景を使っているときのみ、1つのテキストにだけ設定することができます。
                  <br />※MINTIAロゴありの背景を使っている場合は、ロゴの上にはテキストを表示できません。
                  <br />
                  ※MINTIAの商品名やブランド棄損に抵触しそうな文字、公序良俗に反する文字は打てない設定になっています。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="step-section">
          <div class="step-title">
            <img
              class="step-title__img"
              :src="require('@/assets/images/home-page/top_h_yellow.svg')"
            />
            <div class="step-title__subtitle">
              <span class="step-number">step 3</span>
              <p class="step-name">保存・印刷しよう</p>
            </div>
            <p class="txt-subtitle">SAVE / PRINT</p>
          </div>
          <div class="step-content">
            <div class="step-content__wrapper">
              <div class="step3-content__img">
                <img
                  class="step3-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step3_1.png')
                  "
                />
                <img
                  class="step3-img"
                  :src="
                    require('@/assets/images/home-page/top_img_step3_2.png')
                  "
                />
              </div>
              <div class="step3-content__txt">
                <p class="txt-1">
                  シールプリントに対応したマルチコピー機があるコンビニやご家庭のプリンターで、すぐにMYラベルが印刷できます！
                </p>
                <p class="txt-2">
                  ※A4用紙の場合は「フチなし」設定にしてください。
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="guide-from-store">
        <div class="footer-top_wrapper">
          <div class="guide-from-store_title">
            コンビニでのシールプリントは<br />こちらから。
          </div>
          <div class="guide-from-store_icon">
            <img :src="require('@/assets/images/home-page/top_arrow.png')" />
          </div>
          <div class="btn-group">
            <a
              class="s-button white-blue-btn btn-option"
              href="https://networkprint.ne.jp/Lite/start?lang=jajp"
              target="_blank"
              rel="noopener"
            >
              <span class="txt_first">コンビニで簡単</span>
              <br />
              <span class="txt_second">ネットワークプリント</span>
            </a>
          </div>
        </div>
        <div class="guide-from-store_link">
          <router-link class="center-text" :to="{ name: 'faq' }">
            {{ mappingLabels.FAQlink }}
          </router-link>
        </div>
        <div class="guide-from-store_link">
          <a
            class="center-text"
            href="https://www.asahi-gf.co.jp/web-service/asahi-gf/customer/mintia/form.wsp.html?CMD=onForm"
            target="_blank"
            rel="noopener"
            >「ミンティア」MYラベルメーカーに <br />
            関するお問い合わせ</a
          >
        </div>
      </div>
    </div>
    <div class="home-page_button-group">
      <router-link
        class="s-button blue-btn"
        :to="{ name: mainTool }"
        :title="mappingLabels.fileManagement"
        >{{ mappingLabels.makeSticker }}</router-link
      >
      <a
        href="https://fun.asahi-gf.co.jp/"
        class="s-button white-blue-btn mt-3"
        target="_blank"
      >
        <img
          :src="require('@/assets/images/home-page/top_btn_toasahi.svg')"
        />へもどる
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'home.scss';
</style>
